import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { APIManagerConfig } from '../apiManager';
import { Zone } from '../../../store/entities/zones/zones.types';

const ZonesServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getZonesList: (includeDetails?: boolean): Promise<Zone[]> =>
      HTTPBase.get(`farm/${config.farmId}/zones`, { params: { includeDetails } }).then((res) => res.data),
    getZone: (zoneId): Promise<Zone> => HTTPBase.get(`farm/${config.farmId}/zones/${zoneId}`).then((res) => res.data),
    createZone: (zone: Partial<Zone>, formName: FormName): Promise<any> =>
      HTTPBase.post(`farm/${config.farmId}/zones`, zone, { headers: { formName } }).then((res) => res.data),
    updateZone: (zone: Partial<Zone>, formName: FormName): Promise<any> =>
      HTTPBase.patch(`farm/${config.farmId}/zones/${zone.id}`, zone, { headers: { formName } }).then((res) => res.data),
    deleteZone: (zoneId, formName: FormName): Promise<any> =>
      HTTPBase.delete(`farm/${config.farmId}/zones/${zoneId}`, { headers: { formName } }).then((res) => res.data),
  };
};

export default ZonesServiceFactory;
